export const logResult=(value:unknown)=>{const r=String(value||'PENDING').toUpperCase();return r==='LOSE'?'LOSS':r;};
export const LOG_START = '2026-09-16';
export type LogBet = {id:string;stream_id:string;stream_name:string;date:string;off_at?:string|null;track:string;race:string;runner:string;result:string;stake:number|null;pnl:number|null;price:number|null};
const finite=(v:number|null)=>v!=null&&Number.isFinite(v);
export function logMetrics(input:LogBet[]) {
 const rows=input.filter(r=>r.date>=LOG_START), settled=rows.filter(r=>['WIN','LOSS'].includes(r.result));
 const priced=settled.filter(r=>finite(r.pnl)&&finite(r.stake)&&r.stake!>0);
 const staked=priced.reduce((s,r)=>s+r.stake!,0),profit=priced.reduce((s,r)=>s+r.pnl!,0);
 // Aggregate simultaneous race starts before calculating equity: arbitrary stream order must not inflate drawdown.
 const groups=new Map<string,number>();let missingTimes=0;
 for(const r of priced){const valid=r.off_at&&Number.isFinite(Date.parse(r.off_at));if(!valid)missingTimes++;
 const key=valid?new Date(r.off_at!).toISOString():r.date+'T23:59:59.999Z';
 groups.set(key,(groups.get(key)||0)+r.pnl!);}
 let equity=0,peak=0,drawdown=0;
 const curve=Array.from(groups).sort(([a],[b])=>a.localeCompare(b)).map(([time,pnl])=>{
 equity+=pnl;peak=Math.max(peak,equity);drawdown=Math.max(drawdown,peak-equity);
 return {time,pnl,equity,drawdown:peak-equity};
 });
 const wins=settled.filter(r=>r.result==='WIN').length;
 return {bets:rows.length,settled:settled.length,wins,pending:rows.filter(r=>!['WIN','LOSS','VOID'].includes(r.result)).length,
 voids:rows.filter(r=>r.result==='VOID').length,unpriced:settled.length-priced.length,staked,profit,
 returns:staked+profit,roi:staked?profit/staked*100:null,strikeRate:settled.length?wins/settled.length*100:null,
 drawdown,currentDrawdown:peak-equity,missingTimes,curve};
}
